import { create } from "zustand";

export interface InAppNotification {
  id: string;
  title: string;
  message: string;
  data?: Record<string, unknown>;
  read: boolean;
  created_at: string;
}

interface NotificationState {
  notifications: InAppNotification[];
  unreadCount: number;
  isPanelOpen: boolean;
  isLoading: boolean;

  setNotifications: (notifications: InAppNotification[]) => void;
  addNotification: (notification: InAppNotification) => void;
  markAsRead: (notificationId: string) => void;
  markAllAsRead: () => void;
  setPanelOpen: (isOpen: boolean) => void;
  setLoading: (isLoading: boolean) => void;
}

export const useNotificationStore = create<NotificationState>(set => ({
  notifications: [],
  unreadCount: 0,
  isPanelOpen: false,
  isLoading: false,

  setNotifications: notifications =>
    set({
      notifications,
      unreadCount: notifications.filter(n => !n.read).length,
    }),

  addNotification: notification =>
    set(state => {
      const exists = state.notifications.some(n => n.id === notification.id);
      if (exists) return state;
      const newNotifications = [notification, ...state.notifications];
      return {
        notifications: newNotifications,
        unreadCount: newNotifications.filter(n => !n.read).length,
      };
    }),

  markAsRead: notificationId =>
    set(state => {
      const notifications = state.notifications.map(n => (n.id === notificationId ? { ...n, read: true } : n));
      return {
        notifications,
        unreadCount: notifications.filter(n => !n.read).length,
      };
    }),

  markAllAsRead: () =>
    set(state => ({
      notifications: state.notifications.map(n => ({ ...n, read: true })),
      unreadCount: 0,
    })),

  setPanelOpen: isOpen => set({ isPanelOpen: isOpen }),

  setLoading: isLoading => set({ isLoading }),
}));
